import { useTranslation } from 'react-i18next';
import { TeeSectionHeader } from '@/components/ui/tee-section-header';
import { TeeLoader } from '@/components/ui/tee-loader';
import { LocationSwitcher } from '@/components/organisms/LocationSwitcher/LocationSwitcher';
import { useGamePlanLocation } from '@/hooks/useGamePlanLocation';
import { useGamePlanOverview } from '@/hooks/useGamePlanTracker';
import { OnboardingWizard } from './components/OnboardingWizard';
import { CurrentWeekBoard } from './components/CurrentWeekBoard';

export default function CurrentWeekPage() {
  const { t } = useTranslation();
  const { locations, locationId, setLocationId, currentLocation } =
    useGamePlanLocation();

  const { data: overview, isLoading, refetch } = useGamePlanOverview(locationId);

  const switcher =
    locations && locations.length > 1 && locationId ? (
      <LocationSwitcher
        currentLocationId={locationId}
        currentLocationName={currentLocation?.name ?? ''}
        onSelect={setLocationId}
      />
    ) : undefined;

  // Onboarded view leads with the hero (no page title card); loading and
  // onboarding keep a lightweight section header for context.
  if (locationId && !isLoading && overview?.onboarded && overview.currentWeek) {
    return (
      <div className="section_container">
        <CurrentWeekBoard
          locationId={locationId}
          initialData={overview.currentWeek}
          locationName={currentLocation?.name}
          switcher={switcher}
        />
      </div>
    );
  }

  return (
    <div className="section_container">
      <TeeSectionHeader
        title={t('gamePlan.currentWeekTitle', 'Current Week')}
        description={t(
          'gamePlan.currentWeekDescription',
          'Your launch to-dos for the week, with templates and activity logging.',
        )}
        actionNode={switcher}
      />

      {!locationId || isLoading ? (
        <div className="section_body">
          <TeeLoader size="md" text={t('common.loading', 'Loading…')} />
        </div>
      ) : !overview?.onboarded ? (
        <OnboardingWizard
          locationId={locationId}
          defaultGoal={overview?.defaults?.foundingMemberGoal ?? 50}
          defaultDate={overview?.defaults?.grandOpeningDate ?? ''}
          onComplete={() => refetch()}
        />
      ) : null}
    </div>
  );
}
